module.exports = __webpack_public_path__ + "static/media/transferSalaryReport.885634a0.svg";